import { CustomerTypeModel } from "../models/CustomerTypeModel";
import API, { client } from "./API";

const CustomerTypeService = {
  async getAllCustomerTypes() {
    const response = await API().get("CustomerType", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularCustomerType(customerType_id: number) {
    const response = await API().get("CustomerType");
    return response.data.filter(
      (cur_customerType: CustomerTypeModel) =>
        cur_customerType.customerTypeId === customerType_id
    )[0];
  },
  async createCustomerType(data: CustomerTypeModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `CustomerType/${id}` : "CustomerType",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default CustomerTypeService;
